import React from 'react';

import SavedReason, { LoadReason } from 'src/components/SavedReason/SavedReason';

import styles from './Privilege.module.scss';

interface PrivilegeProps {
  title: string;
  subtitles?: Array<string>;
  warning?: string;
  loadReason?: LoadReason;
  canReadReason?: boolean;
  onRevoke?: () => void;
  onEdit?: () => void;
}

const Privilege = ({ title, subtitles, warning, loadReason, canReadReason, onEdit, onRevoke }: PrivilegeProps) => (
  <div className={styles.container} data-testid="privilege">
    <div className={styles.text}>
      <div className={styles.title}>{title}</div>
      {subtitles && subtitles.map((subtitle, index) => {
        if (subtitle) 
          return <div key={`${index}`} className={styles.subtitle} title={subtitle}>{subtitle}</div>

        return null;
      })}
      <div className={styles.warning}>{warning}</div>
    </div>
    {loadReason && <SavedReason loadReason={loadReason} canReadReason={canReadReason} inline />}
    {onEdit && (
      <button className={styles.edit} onClick={onEdit} type="button">
        Edit
      </button>
    )}
    {onRevoke && (
      <button className={styles.revoke} onClick={onRevoke} type="button">
        Revoke
      </button>
    )}
  </div>
);

export default Privilege;
